<template>
  <div class="mobile server-progress">
    <div class="server-progress-text">
      {{ $t('mwr.dragon.serverProgress') }}
    </div>
    <div class="progress-wrap">
      <div class="progress-inner-wrap">
        <div class="progress-inner" :style="{ width: calcProgress() + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { inject } from 'vue'
const mwrData = inject('mwrData')
// import { defineProps } from 'vue'
// const props = defineProps({
//   currentProgress: {
//     type: Number,
//     default: 0,
//   },
//   total: {
//     type: Number,
//     default: 0,
//   }
// })
const calcProgress = () => {
  // alert(mwrData.shootDetail.totalDragonHp + ' ' + mwrData.shootDetail.currentDragonHp)
  if (mwrData.shootDetail.totalDragonHp === 0) {
    return 0
  }
  if (mwrData.shootDetail.currentDragonHp >= mwrData.shootDetail.totalDragonHp) {
    return 100
  }
  return (mwrData.shootDetail.currentDragonHp / mwrData.shootDetail.totalDragonHp) * 100
}
</script>

<style scoped lang="less" src="./mobile_style.less"></style>